export const DAY_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const TIME_AM_PM = 'h:mm A';
export const TIME_24H = 'HH:mm';
